import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

/**
 * Detects `#session_id=` in the URL fragment, exchanges it for our session cookie,
 * then redirects to the target page. Rendered by App when the URL has session_id.
 */
export default function AuthCallback() {
    const { exchangeGoogleSession } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = location.hash || window.location.hash || "";
        const sid = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash).get("session_id");
        if (!sid) {
            navigate("/signin");
            return;
        }
        (async () => {
            try {
                await exchangeGoogleSession(sid);
                // Clean hash from URL
                history.replaceState(null, "", window.location.pathname + window.location.search);
                toast.success("Signed in with Google.");
                navigate("/passport");
            } catch (err) {
                toast.error("Google sign-in failed. Please try again.");
                navigate("/signin");
            }
        })();
    }, [exchangeGoogleSession, location.hash, navigate]);

    return (
        <div className="min-h-[70vh] bg-[var(--bg)] flex items-center justify-center px-6">
            <div className="text-center" data-testid="auth-callback">
                <div className="animate-pulse text-xs uppercase tracking-[0.28em] text-[var(--fg-dim)] font-body mb-3">
                    Signing you in…
                </div>
                <div className="font-display font-black text-[var(--fg)] text-2xl uppercase tracking-tight">
                    Hold on, rider.
                </div>
            </div>
        </div>
    );
}
